import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface CommonState {
  boardState: any;
  actionsUserState: any;
  actionsProjectState: any;
  actionsTaskState: any;
  currentRoute: any;
  setActionsUserState: (u: any) => void;
  setActionsProjectState: (u: any) => void;
  setActionsTaskState: (u: any) => void;
  setBoardState: (u: any) => void;
  setCurrentRoute: (u: any) => void;
  setNullAllState: () => void;
}

export const useCommon = create<CommonState>()(
  persist(
    (set) => ({
      actionsUserState: null,
      actionsProjectState: null,
      actionsTaskState: null,
      boardState: null,
      currentRoute: null,
      setActionsTaskState: (actionsTaskState: any) => {
        set({ actionsTaskState });
      },
      setActionsProjectState: (actionsProjectState: any) => {
        set(s => (Object.assign(s, actionsProjectState)));
      },
      setBoardState: (boardState: any = "/") => {
        set({ boardState });
      },
      setActionsUserState: (actionsUserState: any) => {
        set({ actionsUserState });
      },
      setCurrentRoute: (currentRoute: any) => {
        set({ currentRoute });
      },
      setNullAllState: () => {
        set({
          actionsUserState: null,
          actionsProjectState: null,
          boardState: null,
          currentRoute: null,
        });
      },
    }),
    {
      name: "common-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
